import axios from "axios";
import { toast } from "react-toastify";
import getApiBaseUrl from "helpers/getApiUrl";
import React, { useEffect, useState, useRef } from "react";
import { emailRegex } from "helpers/constants/validation_constants";

import ProgressBar from "@ramonak/react-progress-bar";
import logo from '../assets/logo.png';

import { useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
//
import { RootState } from "redux/store";

interface Props {
  isPdfLoaded: boolean;
  savingPdfStatus: boolean;
  savePdf: () => void;
  rejectSign: (commentText: string) => void;
  setIsAuditHistoryShown: any;
}

export const MenuBar: React.FC<Props> = ({
  isPdfLoaded,
  savingPdfStatus,
  savePdf,
  rejectSign,
  setIsAuditHistoryShown,
}) => {
  const [isRejectMenuOpen, setIsRejectMenuOpen] = useState(false);
  const [isPdfViewerOpen, setIsPdfViewerOpen] = useState(false);
  const [isDocumentViewerOpen, setIsDocumentViewerOpen] = useState(false);
  const [documentLiveUrl, setDocumentLiveUrl] = useState("");
  //
  const [isFinishAlertShown, setIsFinishAlertShown] = useState(false);
  const [isAgreeCheckBoxChecked, setIsAgreeCheckBoxChecked] = useState(false);
  const [isIncompleteFieldsAlertShown, setIsIncompleteFieldsAlertShown] = useState(false);
  const [isEmailErrorShown, setIsEmailErrorShown] = useState(false);

  //
  const [commentText, setCommentText] = useState("");
  const [pdfLiveUrl, setPdfLiveUrl] = useState("");
  const [brandLogo, setBrandLogo] = useState(logo);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [mobileView, setMobileView] = useState(false);

  const toggleDropDown = () => setDropdownOpen((prevState) => !prevState);

  const trackerData = useSelector(
    (state: RootState) => state.allFinalDataReducer
  );

  const validateAllRequireFieds = () => {
    if (trackerData.completedNoOfFields === trackerData.totalNoOfFields) {
      const allEmails = Object.values(allEmailData).flat() as any[];

      const hasInvalidEmail = allEmails.some((item) => {
        const val = item.value?.trim() ?? "";
        return val !== "" && !emailRegex.test(val);
      });


      if (hasInvalidEmail) {
        setIsEmailErrorShown(true);
        return;
      }
      setIsFinishAlertShown(true);
    } else {
      setIsIncompleteFieldsAlertShown(true);
    }
  };

  console.log("trackerData", trackerData);

  const basicInfoData = useSelector((state: RootState) => state.basicInfoData);
  const signatureList = useSelector((state: RootState) => state.signatureList);
  const checkboxList = useSelector((state: RootState) => state.checkboxList);
  const emailList = useSelector((state: RootState) => state.emailList);
  const pickList = useSelector((state: RootState) => state.pickList);
  const dateList = useSelector((state: RootState) => state.dateList);
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);

  const collectInProgressElements = () => {
    const elements: any[] = [];
    const base64OfPng = signatureList?.encodedImgData;
    const signerName = signatureList?.signerName || "";
    const signedDate = signatureList?.signedDate || "";
    if (signatureList?.allSignatureData) {
      Object.values(signatureList.allSignatureData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (base64OfPng) {
              elements.push({
                id: item.coordinateId,
                value: base64OfPng,
                signerName,
                signedDate,
              });
            }
          });
        }
      });
    }
    if (textList?.allTextData) {
      Object.values(textList.allTextData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (item.value !== undefined && item.value !== null && String(item.value).trim().length > 0) {
              elements.push({ id: item.coordinateId, value: item.value });
            }
          });
        }
      });
    }
    if (dateList?.allDateData) {
      Object.values(dateList.allDateData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (item.value !== undefined && item.value !== null && String(item.value).trim().length > 0) {
              elements.push({ id: item.coordinateId, value: item.value });
            }
          });
        }
      });
    }
    if (checkboxList?.allCheckboxData) {
      Object.values(checkboxList.allCheckboxData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (item.value !== undefined && item.value !== null) {
              elements.push({ id: item.coordinateId, value: String(item.value) });
            }
          });
        }
      });
    }
    if (emailList?.allEmailData) {
      Object.values(emailList.allEmailData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (item.value !== undefined && item.value !== null && String(item.value).trim().length > 0) {
              elements.push({ id: item.coordinateId, value: item.value });
            }
          });
        }
      });
    }
    if (pickList?.allPicklistData) {
      Object.values(pickList.allPicklistData).forEach((pageElements: any) => {
        if (Array.isArray(pageElements)) {
          pageElements.forEach((item: any) => {
            if (item.value !== undefined && item.value !== null && String(item.value).trim().length > 0) {
              elements.push({ id: item.coordinateId, value: item.value });
            }
          });
        }
      });
    }
    return elements;
  };

  const allEmailData = useSelector((state: RootState) => state.emailList.allEmailData);

  const textList = useSelector((state: RootState) => state.textList);
  console.log("textList:", textList);

  const dateListt = useSelector((state: RootState) => state.dateList);
  console.log("dateList:", dateListt);

  useEffect(() => {
    if (basicInfoData) {
      console.log("basicInfoo", basicInfoData);
      const { uuid, uuidTemplateInstance, salesforceOrgId } = basicInfoData;


      // Set the URLs
      const newPdfLiveUrl = `${process.env.REACT_APP_API_URL}/docSignRequestInstance/fetchpdf?id=${uuid}&uuid_template_instance=${uuidTemplateInstance}`;
      const newDocumentLiveUrl = `${process.env.REACT_APP_API_URL}/docSignRequestInstance/getPdfWithCoordinates?document_uuid=${uuid}&document_sign_request_uuid=${uuidTemplateInstance}`;

      // const newPdfLiveUrl = `http://localhost:8085/EwSignApi/fetchpdf?uuid=${uuid}&uuid_template_instance=${uuidTemplateInstance}`;
      // const newDocumentLiveUrl = `http://localhost:8085/EwSignApi/docSignRequestInstance/getPdfWithCoordinates?document_uuid=${uuid}&document_sign_request_uuid=${uuidTemplateInstance}`;

      setPdfLiveUrl(newPdfLiveUrl);
      setDocumentLiveUrl(newDocumentLiveUrl);
      if (salesforceOrgId) {
        setBrandLogo(
          `${process.env.REACT_APP_API_URL}/custom-branding/fetchBrandLogo?orgId=${encodeURIComponent(
            salesforceOrgId
          )}`
        );
      } else {
         setBrandLogo(logo);
      }

      // Log the new URLs
      console.log("PdfLiveUrl", newPdfLiveUrl);
      console.log("DocumentLiveUrl", newDocumentLiveUrl);
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (window.innerWidth < 595) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [])

  const handleRejection = () => {
    if (commentText) {
      rejectSign(commentText);
      setIsRejectMenuOpen(false);
    }
  };

  const closeCurrentModal = () => {
    setIsRejectMenuOpen(false);
    setIsFinishAlertShown(false);
    setIsIncompleteFieldsAlertShown(false);
  };

  const handleViewPdf = async () => {
    try {
      setIsPdfViewerOpen(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePrintPdf = async () => {
    try {
      window.open(pdfLiveUrl, "_blank", "");
    } catch (err) {
      console.log(err);
    }
  };
  const handleDownloadPdf = async () => {
    try {
      const response = await axios.get(pdfLiveUrl, {
        responseType: "blob",
        headers: {
          "ngrok-skip-browser-warning": "true",
        },
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "Unsigned_Document.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.log(err);
      toast.error("Failed to download unsigned document.");
    }
  };

  const handleViewDocument = async () => {
    try {
      setIsDocumentLoading(true);
      const inProgressData = collectInProgressElements();
      const apiUrl = process.env.REACT_APP_API_URL || getApiBaseUrl();

      const response = await axios.post(
        `${apiUrl}/docSignRequestInstance/getPdfWithCoordinates`,
        {
          document_uuid: basicInfoData.uuid,
          document_sign_request_uuid: basicInfoData.uuidTemplateInstance,
          allElementsData: inProgressData,
        },
        {
          responseType: "blob",
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      setDocumentLiveUrl(blobUrl);
      setIsDocumentViewerOpen(true);
    } catch (err) {
      console.log("Error viewing signed document:", err);
      toast.error("Failed to load signed document. Please try again.");
    } finally {
      setIsDocumentLoading(false);
    }
  };

  const handleDownloadDocument = async () => {
    try {
      setIsDocumentLoading(true);
      let downloadBlobUrl = documentLiveUrl;
      if (!downloadBlobUrl || !downloadBlobUrl.startsWith("blob:")) {
        const inProgressData = collectInProgressElements();
        const apiUrl = process.env.REACT_APP_API_URL || getApiBaseUrl();

        const response = await axios.post(
          `${apiUrl}/docSignRequestInstance/getPdfWithCoordinates`,
          {
            document_uuid: basicInfoData.uuid,
            document_sign_request_uuid: basicInfoData.uuidTemplateInstance,
            allElementsData: inProgressData,
          },
          {
            responseType: "blob",
            headers: {
              "ngrok-skip-browser-warning": "true",
            },
          }
        );

        const blob = new Blob([response.data], { type: "application/pdf" });
        downloadBlobUrl = URL.createObjectURL(blob);
      }

      const a = document.createElement("a");
      a.href = downloadBlobUrl;
      a.download = "Signed_Document.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log("Error downloading signed document:", err);
      toast.error("Failed to download signed document. Please try again.");
    } finally {
      setIsDocumentLoading(false);
    }
  };
  return (
    <>
      <div className={`menubar-container p-2 px-3 ${mobileView ? "menubar-container-mobile" : ""}`}>
        <div
          className="d-flex menubar-inner-container"
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={brandLogo}
            className="logo"
            alt="logo img"
            onError={() => setBrandLogo(logo)}
          />

          <div className="custom-progressbar-container">
            {/*  */}

            <ProgressBar
              completed={trackerData.completedNoOfFields}
              maxCompleted={trackerData.totalNoOfFields}
              isLabelVisible={false}
              height="5px"
              bgColor="#ece5c7"
              baseBgColor="#878479"
            />
            <div className="text-center mb-1" style={{ color: "#1d1c1cb3" }}>
              {trackerData.completedNoOfFields} of {trackerData.totalNoOfFields}{" "}
              required fields completed
            </div>

            {/*  */}
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center header-main-container gap-sm-2 " style={mobileView ? { width: "auto", marginRight: "0", fontSize: "12px" } : {}}>
          {isPdfLoaded && (
            <>
              {!mobileView && (
                <button
                  className="submit-btn btn"
                  // onClick={savePdf}
                  onClick={validateAllRequireFieds}
                >
                  Submit Document
                </button>
              )}

              <Dropdown
                style={mobileView ? { fontSize: "12px" } : {}}
                isOpen={dropdownOpen}
                toggle={toggleDropDown}
                direction={"down"}
              >
                <DropdownToggle
                  caret={!mobileView}
                  style={mobileView ? {} : { backgroundColor: "#354259", color: "white" }}
                  color={mobileView ? "light" : "black"}
                  className={mobileView ? "mobile-actions-toggle" : "fw-bold"}
                  aria-label="Document actions"
                >
                  {mobileView ? <i className="fa-solid fa-ellipsis-vertical"></i> : "Options"}
                </DropdownToggle>
                <DropdownMenu end={mobileView} style={mobileView ? { minWidth: 220, fontSize: "13px" } : { minWidth: 150 }}>
                  {mobileView && (
                    <>
                      <DropdownItem onClick={validateAllRequireFieds}>
                        Submit Document
                      </DropdownItem>
                      <DropdownItem divider />
                    </>
                  )}
                  <DropdownItem onClick={() => setIsRejectMenuOpen(true)}>
                    Reject
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handlePrintPdf();
                    }}
                  >
                    Print
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setIsAuditHistoryShown(true);
                    }}
                  >
                    View History
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      window.open("https://www.eruditeworks.com/contact-us", "_blank");
                    }}
                  >
                    Help & Support
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() => {
                      handleViewPdf();
                    }}
                  >
                    View Unsigned Document
                  </DropdownItem>
                  <DropdownItem onClick={() => handleDownloadPdf()}>
                    Download Unsigned Document
                  </DropdownItem>
                  <DropdownItem onClick={handleViewDocument}>
                    View Signed Document
                  </DropdownItem>
                  <DropdownItem onClick={handleDownloadDocument}>
                    Download Signed Document
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

              {/* <button
                className="submit-btn btn"
                onClick={() => setIsRejectMenuOpen(true)}
              >
                Reject
              </button> */}
            </>
          )}
        </div>
      </div>

      {/*  */}
      <PdfViewer
        isPdfViewerOpen={isPdfViewerOpen}
        setIsPdfViewerOpen={setIsPdfViewerOpen}
        pdfLiveUrl={pdfLiveUrl}
        handleDownloadPdf={handleDownloadPdf}
      />
      <DocumentViewer
        isDocumentViewerOpen={isDocumentViewerOpen}
        setIsDocumentViewerOpen={setIsDocumentViewerOpen}
        documentLiveUrl={documentLiveUrl}
        handleDownloadDocument={handleDownloadDocument}
      />

      {/*  */}

      {/* check to agree modal */}
      <Modal
        isOpen={isFinishAlertShown}
        onClosed={closeCurrentModal}
        centered
        className="modal-container"
        toggle={closeCurrentModal}
        fade={false}
        size={"lg"}
      >
        <ModalHeader>Do You Agree ?</ModalHeader>
        <ModalBody>
          <div>
            <div className="form-group mb-0">
              <div className="d-flex gap-2">
                <input
                  type="checkbox"
                  className="inline d-flex align-self-start mt-1"
                  id="terms"
                  defaultValue="false"
                  onChange={(e) => {
                    setIsAgreeCheckBoxChecked(e.target.checked);
                  }}
                />
                <label
                  className="x-small font-weight-normal mx-2"
                  htmlFor="terms"
                >
                  By clicking this checkbox, I agree that this mark will serve
                  as my signature for the document. I also understand that
                  recipients of documents I sign will be able to see my signing
                  details, including but not limited to my Email ID, Phone
                  Number.
                </label>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn " onClick={closeCurrentModal}>
            Cancel
          </button>
          <span className="px-2"> </span>
          <button
            onClick={() => {

              savePdf();
              closeCurrentModal();
            }}
            className={`btn custom-btn1 ${!isAgreeCheckBoxChecked ? "text-dark bg-secondary" : null
              }`}
            disabled={!isAgreeCheckBoxChecked}
          >
            Done
          </button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isIncompleteFieldsAlertShown}
        onClosed={closeCurrentModal}
        centered
        className="modal-container"
        toggle={closeCurrentModal}
        fade={false}
        size={"lg"}
        style={mobileView ? { width: "90%" } : { width: "100%" }}
      >
        <ModalHeader>Incomplete Fields</ModalHeader>
        <ModalBody>
          <div>
            <p>Please complete all required fields before submitting the document.</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => {
              closeCurrentModal();
            }}
            className='btn custom-btn1 text-dark bg-secondary'
          >
            Done
          </button>
        </ModalFooter>
      </Modal>
      {/*  */}

      <Modal
        isOpen={isEmailErrorShown}
        onClosed={() => setIsEmailErrorShown(false)}
        centered
        className="modal-container"
        toggle={() => setIsEmailErrorShown(false)}
        fade={false}
        size={"lg"}
        style={mobileView ? { width: "90%" } : { width: "100%" }}
      >
        <ModalHeader>Invalid Email</ModalHeader>
        <ModalBody>
          <div>
            <p>One or more email fields contain an invalid email address.</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => setIsEmailErrorShown(false)}
            className='btn custom-btn1 text-dark bg-secondary'
          >
            Done
          </button>
        </ModalFooter>
      </Modal>

      {/*  */}
      {/* reject to sign */}
      <Modal
        isOpen={isRejectMenuOpen}
        onClosed={closeCurrentModal}
        centered
        className="modal-container"
        toggle={closeCurrentModal}
        fade={false}
        size={"lg"}
        style={mobileView ? { width: "90%" } : { width: "100%" }}
      >
        <ModalHeader>Reject To Sign</ModalHeader>
        <ModalBody>
          <div>
            <FormGroup>
              <Label for="exampleText" className="text-dark">
                You're about to reject to sign,
                <br /> Note that all the changes you've made to this document
                will be lost. We advise you to carefully review this again.
              </Label>

              <h6 className="fw-bold my-3" style={{ fontSize: "1rem" }}>
                Please provide your reason for declining here:
              </h6>
              <Input
                type="textarea"
                name="text"
                id="exampleText"
                style={{ minHeight: 150 }}
                placeholder="Reason For Reject"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              />
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn " onClick={closeCurrentModal}>
            Cancel
          </button>
          <span className="px-2"> </span>
          <button
            onClick={handleRejection}
            className={`btn custom-btn1 ${!commentText ? "text-dark bg-secondary" : null
              }`}
            disabled={!commentText}
          >
            Done
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const DocumentViewer = ({
  isDocumentViewerOpen,
  setIsDocumentViewerOpen,
  documentLiveUrl,
  handleDownloadDocument,
}: {
  isDocumentViewerOpen: boolean;
  setIsDocumentViewerOpen: (open: boolean) => void;
  documentLiveUrl: string;
  handleDownloadDocument: () => void;
}) => {
  const [numPages, setNumPages] = useState(0);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const zoomContainerRef = useRef<any>(null);
  console.log("documentLiveUrl in DocumentViewer", documentLiveUrl);
  const zoomControl = (operation: string) => {
    switch (operation) {
      case "in":
        zoomContainerRef.current.zoomIn(0.1);
        break;
      case "out":
        zoomContainerRef.current.zoomOut();
        break;

      default:
        break;
    }
  };

  return (
    <Modal
      isOpen={isDocumentViewerOpen}
      onClosed={() => setIsDocumentViewerOpen(false)}
      centered
      className="modal-container"
      toggle={() => setIsDocumentViewerOpen(false)}
      fade={false}
      fullscreen
    >
      <ModalBody className="p-0">
        <div
          className="document-viewer-header d-flex justify-content-center gap-3 py-2 text-light mb-2"
          style={{
            fontSize: "1rem",
            backgroundColor: "#354259",
            position: "sticky",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <span>
            <i
              className="fa-solid fa-download cursor-pointer"
              onClick={() => handleDownloadDocument()}
            ></i>
          </span>
          <span>
            <i className="fa-solid fa-print cursor-pointer"></i>
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "5px",
            padding: "10px",
          }}
        >
          <TransformWrapper
            maxScale={3}
            initialScale={1}
            disablePadding
            wheel={{ disabled: true }}
            // disabled={deviceWidth <= 600}
            ref={zoomContainerRef}
          >
            <TransformComponent>
              <Document
                file={documentLiveUrl}
                onLoadSuccess={({ numPages }) => {
                  setNumPages(numPages);
                }}
                renderMode="canvas"
              >
                {[...Array(numPages)].map((_, index) => (
                  <div key={index} className="page-div-signed">
                    <Page
                      pageNumber={index + 1}
                      className="page-section-signed"
                    />
                    <div style={{ textAlign: "right", marginRight: "10px" }} className="fw-bold">
                      {index + 1} of {numPages}
                    </div>
                  </div>
                ))}
              </Document>
            </TransformComponent>
          </TransformWrapper>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn custom-btn1"
          onClick={() => setIsDocumentViewerOpen(false)}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

const PdfViewer = ({
  isPdfViewerOpen,
  setIsPdfViewerOpen,
  pdfLiveUrl,
  handleDownloadPdf,
}: {
  isPdfViewerOpen: any;
  setIsPdfViewerOpen: any;
  pdfLiveUrl: any;
  handleDownloadPdf: any;
}) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  //
  const [numPages, setNumPages] = useState(0);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const zoomContainerRef = useRef<any>(null);

  const zoomControl = (operation: string) => {
    switch (operation) {
      case "in":
        zoomContainerRef.current.zoomIn(0.1);
        break;
      case "out":
        zoomContainerRef.current.zoomOut();
        break;

      default:
        break;
    }
  };

  return (
    <Modal
      isOpen={isPdfViewerOpen}
      onClosed={() => setIsPdfViewerOpen(false)}
      centered
      // className="modal-container"
      toggle={() => setIsPdfViewerOpen(false)}
      fade={false}
      // size={"xl"}
      fullscreen
    >
      {/* <ModalHeader>Total Pages :- {numPages === 0 ? "" : numPages}</ModalHeader> */}
      <ModalBody className="p-0">
        <div
          className="pdfviewer-header d-flex justify-content-center gap-3 py-2 text-light mb-2"
          style={{
            fontSize: "1rem",
            backgroundColor: "#354259",
            position: "sticky",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          {deviceWidth >= 600 && (
            <>
              <span>
                <i
                  className="fa-solid fa-magnifying-glass-plus cursor-pointer"
                  onClick={() => zoomControl("in")}
                ></i>
              </span>
              <span>
                <i
                  className="fa-solid fa-magnifying-glass-minus cursor-pointer"
                  onClick={() => zoomControl("out")}
                ></i>
              </span>
            </>
          )}
          <span>
            <i
              className="fa-solid fa-download cursor-pointer"
              onClick={() => handleDownloadPdf()}
            ></i>
          </span>
          <span>
            <i className="fa-solid fa-print"></i>
          </span>
        </div>
        <div className="d-flex justify-content-center print-pdf-main-container">
          <TransformWrapper
            maxScale={3}
            initialScale={1}
            disablePadding
            wheel={{ disabled: true }}
            disabled={deviceWidth <= 600}
            ref={zoomContainerRef}
          >
            <TransformComponent>
              <Document
                file={pdfLiveUrl}
                onLoadSuccess={({ numPages }) => {
                  setNumPages(numPages);
                }}
                renderMode="canvas"
              // style={{ overflowX: "scroll" }}
              >
                {[...Array(numPages)].map((_, index) => {
                  return (
                    <div
                      key={index}
                      className="page-div"
                    // className="m-0 p-0 mb-5 my-3"
                    >
                      <Page
                        pageNumber={index + 1}
                        className="page-section"
                      // style={{ overflowX: "scroll" }}
                      />
                      <div style={{ textAlign: "right" }} className="fw-bold">
                        {index + 1} of {numPages}
                      </div>
                    </div>
                  );
                })}
              </Document>
            </TransformComponent>
          </TransformWrapper>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn custom-btn1"
          onClick={() => setIsPdfViewerOpen(false)}
        >
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};
